// client
import { gql } from '@apollo/client';

const FETCH_SUPPORT_TAGS = gql`
  query SupportTags {
    supportTags {
      id
      name
      color
    }
  }
`;

export default FETCH_SUPPORT_TAGS;
